export class GTransitionAnimationsConstants {
    static bBurnMoreTransitionActive = false;

    static BurnMoreTransitionParameter = 0.0;

    static BurnMoreTransitionDuration = 3.0;

    static bBurnedImageSwipeActive = false;

    static BurnedImageSwipeParameter = 0.0;

    static BurnedImagePosCached = 0.0;
}
